import React from 'react';

class Cube extends React.Component {
	render () {
		return (
			<div className="cube" id={this.props.id}>
				<div className="cube__side cube__side--front"><div className="u-center--absolute u-w--100 u-ph-">{this.props.front}</div></div>
				<div className="cube__side cube__side--left"><div className="u-center--absolute u-w--100 u-ph-">{this.props.left}</div></div>
				<div className="cube__side cube__side--right"><div className="u-center--absolute u-w--100 u-ph-">{this.props.right}</div></div>
				<div className="cube__side cube__side--back"><div className="u-center--absolute u-w--100 u-ph-">{this.props.back}</div></div>
				<div className="cube__side cube__side--top"><div className="u-center--absolute u-w--100 u-ph-">{this.props.top}</div></div>
				<div className="cube__side cube__side--bottom"><div className="u-center--absolute u-w--100 u-ph-">{this.props.bottom}</div></div>
			</div>
		)
	}
}

export default Cube;


// WEBPACK FOOTER //
// ./src/components/Cube.js